import React from 'react'
import './MusicCard.css'
function MusicCard({image, title, release, description}) {
    return (
        <div className='musicCard'>
            
                <img className='musicCard_icon' src={image}/>
                <div className="musicCard_info">
                <h2>{title}</h2>

                <p>Released On: {release}</p>
                <p>{description}</p>
            </div>
            
        </div>
    )
}

export default MusicCard
